module.exports = __webpack_public_path__ + "3ce027fb3727b1d38cf6c0f7fdb48a6f.png";